import { useSocketIOStore } from './socket-io'
import { useExportsStore } from './exports'
import { useAssetsStore } from './assets'
import { useImportsStore } from './imports'
import { useNotificationsStore } from './notifications'

const boundSockets = new WeakSet()

export function registerSocketListeners(vm) {
  const socket = useSocketIOStore().socket
  if (!socket || boundSockets.has(socket)) return
  boundSockets.add(socket)

  useExportsStore().init(vm)
  useAssetsStore().init(vm)
  useImportsStore().init(vm)
  useNotificationsStore().init()
}
